module.exports = __webpack_public_path__ + "static/media/PSSquare.9ce36846.svg";